<template>
    <div data-layout="aurora">
        <aurora-wrapper>
            <aurora-body>
                <slot />
            </aurora-body>
        </aurora-wrapper>
    </div>
</template>

<script>
import AuroraWrapper from "./AuroraWrapper";
import AuroraBody from "./AuroraBody";

export default {
    components: {
        AuroraWrapper,
        AuroraBody,
    },
};
</script>
